namespace Matrix.Visualizer {
    export class GraphEdgeColumns {
        static columnsKey = 'Visualizer.GraphEdge';
    }
}
